// extracted by mini-css-extract-plugin
module.exports = {"circle":"CircularProgressBar_circle__1hIYN","progress_ring":"CircularProgressBar_progress_ring__1zUmI"};